import { DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export interface TradeInvoiceDialogActionsProps {
  readonly isPending: boolean;
  readonly saveDisabled: boolean;
  readonly onCancel: () => void;
  readonly submitLabel?: string;
  // What still blocks the save, in the operator's language. Shown next to the
  // disabled submit button so a blocked create is never unexplained.
  readonly blockers?: readonly string[];
}

export function TradeInvoiceDialogActions({
  isPending,
  saveDisabled,
  onCancel,
  submitLabel = 'Save',
  blockers = [],
}: TradeInvoiceDialogActionsProps) {
  const showBlockers = saveDisabled && !isPending && blockers.length > 0;
  return (
    <DialogFooter>
      {/* Last child + order-first: above the buttons on the mobile
          column-reverse layout, left of them on the desktop row. */}
      <Button type="button" variant="outline" onClick={onCancel} disabled={isPending}>
        Cancel
      </Button>
      <Button type="submit" disabled={saveDisabled}>
        {isPending ? 'Saving…' : submitLabel}
      </Button>
      {showBlockers && (
        <p
          data-testid="save-blockers"
          className="text-muted-foreground text-xs sm:order-first sm:mr-auto sm:self-center"
        >
          {blockers.join(' ')}
        </p>
      )}
    </DialogFooter>
  );
}
